import { render, staticRenderFns } from "./WifiEquipmentView.vue?vue&type=template&id=48fa1830&scoped=true"
import script from "./WifiEquipmentView.vue?vue&type=script&lang=js"
export * from "./WifiEquipmentView.vue?vue&type=script&lang=js"
import style0 from "./WifiEquipmentView.vue?vue&type=style&index=0&id=48fa1830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa1830",
  null
  
)

export default component.exports